import { Box, Flex, Text } from '@chakra-ui/react';
import { FaMedal } from 'react-icons/fa';
import { formatPrice } from '../../utils/formatPrice';
import { Lugar } from './components/Lugar';

export function Ranking({ infoCustomer }) {
  console.log(infoCustomer?.valor_a_alcancar);
  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Flex alignItems="center" gap={2} flexDir="column">
        <FaMedal size={20} />
        <Text color="#2D2D2D" fontSize="21px">
          Meu Ranking
        </Text>
      </Flex>

      <Flex gap={2} alignItems="center" justifyContent="center" flex={1}>
        <Flex flexDir="column" alignItems="center">
          <Text as="span" fontSize="12px" fontWeight="semibold" textTransform="uppercase">
            vendas
          </Text>
          <Text as="span" fontSize="31px" fontWeight="bold" color="#FFA200">
            {infoCustomer?.ranking_vendas_mes}º
          </Text>
          <Text as="span" fontSize="12px" fontWeight="semibold" color="#FFA200">
            lugar
          </Text>
        </Flex>

        <Lugar
          front={formatPrice(infoCustomer?.valor_proximo)}
          distance={formatPrice(infoCustomer?.valor_a_alcancar)}
          ranking={infoCustomer?.ranking_valor_a_alcancar}
          rankingValorProximo={infoCustomer?.ranking_valor_proximo}
          isFrontPrimary={infoCustomer?.valor_a_alcancar <= 0}
          isDistancePrimary={infoCustomer?.ranking_valor_a_alcancar <= 1}
        />
        <Box mt="10px" h="50px" w="3px" bgColor="#FFA200" />
        <Flex flexDir="column" alignItems="center" justifyContent="center">
          <Text as="span" fontSize="12px" fontWeight="semibold" textTransform="uppercase">
            pedidos
          </Text>
          <Text as="span" fontSize="31px" fontWeight="bold" color="#FFA200">
            {infoCustomer?.ranking_pedidos_mes}º
          </Text>
          <Text as="span" fontSize="12px" fontWeight="semibold" color="#FFA200">
            lugar
          </Text>
        </Flex>
        <Lugar
          front={`${infoCustomer?.pedido_proximo} Pedidos`}
          distance={`${infoCustomer?.pedido_a_alcancar} Pedidos`}
          ranking={infoCustomer?.ranking_pedido_a_alcancar}
          isPrimaryPedido={parseInt(infoCustomer?.ranking_pedidos_mes) === 1}
          isDistancePrimary={infoCustomer?.valor_a_alcancar === 0}
          rankingValorProximo={infoCustomer?.ranking_pedido_proximo}
          lastPosition={infoCustomer?.lastPosition}
        />
      </Flex>
    </Flex>
  );
}
